'use client';

import { useEffect, useRef, useState } from 'react';
import { cn } from '@/lib/utils';
import '@/styles/animations.css';
import { Dot } from 'lucide-react';
import GradientText from '@/components/GradientText';
import { useTheme } from 'next-themes';

interface ScrollingBroadcastProps {
  /**
   * 播报内容
   */
  content: string;
  /**
   * 播报速度（秒）
   */
  duration?: number;
  /**
   * 自定义类名
   */
  className?: string;
}

export default function ScrollingBroadcast({
  content,
  duration = 10,
  className,
}: ScrollingBroadcastProps) {
  const [current, setCurrent] = useState(content);
  const [next, setNext] = useState<React.ReactNode | null>(null);
  const [animating, setAnimating] = useState(false);
  const { theme } = useTheme();

  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (content === current) return;

    setNext(content);
    setAnimating(true);

    // timerRef.current = window.setTimeout(() => {

    // }, duration * 1000);

    // return () => {
    //   if (timerRef.current) {
    //     clearTimeout(timerRef.current);
    //   }
    // };
  }, [content, current, duration]);

  return (
    <div className="scroll-3d-container text-xs" style={{ ['--duration' as any]: `${duration}s` }}>
      <div className={`scroll-3d-inner ${animating ? 'animating' : ''}`}>
        <div className="scroll-3d-item current">
          <Dot className="text-text-tertiary" size={26} />
          <GradientText
            colors={['#757575', theme === 'dark' ? '#FFFFFF' : '#000000', '#757575']}
            className="ml-0!"
            textClassName="h-5 leading-5"
            animationSpeed={5}
          >
            {current}
          </GradientText>
        </div>
        {next && (
          <div
            className="scroll-3d-item next text-text-tertiary"
            onAnimationEnd={() => {
              setCurrent(content);
              setNext(null);
              setAnimating(false);
            }}
          >
            <Dot className="text-text-tertiary" size={26} />
            <GradientText
              colors={['#757575', '#FFFFFF', '#757575']}
              textClassName="h-5 leading-5"
              className="ml-0!"
              animationSpeed={5}
            >
              {next}
            </GradientText>
          </div>
        )}
      </div>
    </div>
  );
}
